export const SYNC = 'SYNC';
export const ASYNC_BEGIN = 'ASYNC_BEGIN';
export const ASYNC_SUCCESS = 'ASYNC_SUCCESS';
export const ASYNC_FAILURE = 'ASYNC_FAILURE';
export const ASYNC_DISMISS_ERROR = 'ASYNC_DISMISS_ERROR';
